import { Injectable, Inject } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { SERVICE_URL } from 'src/environments/tokens';
import { User, LoginAttempt, UserRoles } from 'src/app/shared/model';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    public apothekenUsername: string;
    public apothekenPassword: string;
    apothekenBestellung = false;

    serviceUrl: string;

    loginAttempt: LoginAttempt;

    public currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(
        @Inject(SERVICE_URL) serviceUrl: string,
        private http: HttpClient
    ) {
        this.serviceUrl = serviceUrl;
        this.currentUserSubject = new BehaviorSubject<User>(
            JSON.parse(sessionStorage.getItem('currentUser'))
        );
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public get currentUserFullName(): string {
        let user = this.currentUserSubject.value;
        if(!user)
            return '';
        if(!user['vorname'] || !user['nachname'])
            return '';
        return user['vorname'] + ' ' + user['nachname'];
    }

    authenticate(username: string, password: string, recaptchaResult: string) {
        const authString = 'Basic ' + btoa(username + ':' + password);
        this.loginAttempt = {
            username,
            password: authString,
            recaptchaResult: recaptchaResult
        };

        return this.http.get<User>(`${this.serviceUrl}login/`, {params: {recaptchaResult: this.loginAttempt.recaptchaResult}}).pipe(
            map(user => {
                user.token = authString;
                sessionStorage.setItem('currentUser', JSON.stringify(user));
                if(user.username == 'APO41000199') {
                    sessionStorage.setItem('test', 'true');
                }
                this.currentUserSubject.next(user);
                return user;
            })
        );
    }

    logout() {
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('test');
        this.currentUserSubject.next(null);
    }

    getActiveLoginAttempt(): LoginAttempt {
        return this.loginAttempt;
    }

    clearActiveLoginAttempt() {
        this.loginAttempt = null;
    }

    setActiveApothekenBestellung(value: boolean) {
        this.apothekenBestellung = value;
    }

    getActiveApothekenBestellung() {
        return this.apothekenBestellung;
    }

    public setApothekenUsername(name: string) {
        this.apothekenUsername = name;
    }

    public setApothekenPassword(password: string) {
        this.apothekenPassword = password;
    }

    clearApothekenAnfrage() {
        this.apothekenUsername = null;
        this.setApothekenPassword = null;
        this.apothekenBestellung = false;
    }

    getBasicToken(): string {
        if (
            this.apothekenUsername === undefined ||
            this.apothekenUsername === null ||
            this.apothekenPassword === undefined ||
            this.apothekenPassword === null
        ) {
            return null;
        }
        return btoa(this.apothekenUsername + ':' + this.setApothekenPassword);
    }

    updateProfilData(userData) {
      let url = this.serviceUrl+'profil/';
      return this.http.post(url, userData);
    }

    updatePassword(pwData) {
      let url = this.serviceUrl+'profil/password';
      console.log(url);
      return this.http.post(url, pwData);
    }

    getSubs(kundennummer) {
      return this.http.get(this.serviceUrl+'admin/'+kundennummer+'/subs');
    }

    deleteSub(kennung) {
      return this.http.post(this.serviceUrl+'admin/subs/delete', {kundenkennung: kennung});
    }

    public addSub(subData) {
      return this.http.post(this.serviceUrl+'admin/subs/add', subData);
    }

    public changeOrderEmail(email) {
        return this.http.put(this.serviceUrl+'profil/bestell-email', {email: email})
    }

    public changeBga(bga) {
        return this.http.put(this.serviceUrl+'profil/bga', {bga: bga})
    }

    public getProfileData() {
        return this.http.get(this.serviceUrl+'profil/');
    }
}
